var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service from '@ember/service';
import { service } from '@ember/service';
import { assert } from '@ember/debug';
let ErrorHandlerService = (_class = class ErrorHandlerService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "flashMessages", _descriptor2, this);
  }
  handle(changeset, errors) {
    if (Array.isArray(errors)) {
      for (const error of errors) {
        this.generateGlobalErrorMessage(error.code);
      }
      const errorsReturned = this.translateErrors(errors);
      this.addErrorTranslatedInChangeset(changeset, errorsReturned);
    } else {
      this.generateGlobalErrorMessage(errors);
    }
  }
  translateErrors(errors) {
    const translatedErrors = {};
    for (const error of errors) {
      for (const errorDetail of error.details) {
        const {
          field,
          message
        } = errorDetail;
        const messagePath = `validations.backend.${message}`;
        if (!translatedErrors[field]) {
          translatedErrors[field] = [];
        }
        if (this.intl.exists(messagePath)) {
          translatedErrors[field]?.push(this.intl.t(messagePath));
        } else {
          translatedErrors[field]?.push(message);
          assert(`Missing translation for backend error : ${message}`);
        }
      }
    }
    return translatedErrors;
  }
  addErrorTranslatedInChangeset(changeset, errors) {
    for (const field in errors) {
      for (const error of errors[field]) {
        changeset.addError(field, error);
      }
    }
  }
  generateGlobalErrorMessage(error) {
    const messagePath = `validations.backend.${error}`;
    if (this.intl.exists(messagePath)) {
      this.flashMessages.danger(`${this.intl.t('validations.backend.error')} - ${this.intl.t(messagePath)}`);
    } else {
      this.flashMessages.danger(`${this.intl.t('validations.backend.error')} - ${error}`);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "flashMessages", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { ErrorHandlerService as default };